import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { FBPostsService } from './fb-posts-service'
import { AuthService } from '../shared/auth/auth.service';
import { FBData } from './fb-data.model';
@Component({
  selector: 'facebook-posts',
  templateUrl: './fb-posts.component.html'
})
export class FBPostsComponent implements OnInit, OnDestroy {
  fbData: any;
  constructor(private _route: ActivatedRoute,
    private _router: Router,
    private fbPostsService: FBPostsService,
    public authService: AuthService) {
  }
  ngOnInit() {
    this.fbPostsService.getFBPosts().subscribe(
      fbData => {
      this.fbData = fbData;
        console.log("inside this.fbPostsService.getFBPosts()");
        console.log(fbData.data[0].message);
      });
  }
  ngOnDestroy() {

  }
}



// WEBPACK FOOTER //
// ./src/app/facebook-posts/fb-posts.component.ts